import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'receive': return 'ArrowDownLeft';
      case 'send': return 'ArrowUpRight';
      case 'swap': return 'RefreshCw';
      case 'topup': return 'Plus';
      default: return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'receive': return 'text-success';
      case 'send': return 'text-primary';
      case 'swap': return 'text-accent';
      case 'topup': return 'text-secondary';
      default: return 'text-foreground';
    }
  };

  const getActivityLabel = (activity) => {
    switch (activity?.type) {
      case 'receive':
        return `Received ${activity?.amount} ${activity?.asset}`;
      case 'send':
        return `Sent ${activity?.amount} ${activity?.asset}`;
      case 'swap':
        return `Swapped ${activity?.amount} ${activity?.fromAsset} to ${activity?.toAsset}`;
      case 'topup':
        return `Topped up ${activity?.amount} ${activity?.asset}`;
      default:
        return 'Transaction';
    }
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-semibold text-foreground mb-1">Recent Activity</h3>
          <p className="text-sm text-muted-foreground">Your latest transactions</p>
        </div>
        <button className="text-sm text-primary hover:underline">
          View All
        </button>
      </div>

      <div className="space-y-4">
        {activities?.map((activity) => (
          <div 
            key={activity?.id} 
            className="flex items-start gap-4 p-3 rounded-lg hover:bg-muted/50 transition-smooth cursor-pointer"
          >
            <div className={`w-10 h-10 rounded-full flex items-center justify-center bg-current/10 ${getActivityColor(activity?.type)}`}>
              <Icon name={getActivityIcon(activity?.type)} size={18} className={getActivityColor(activity?.type)} />
            </div>
            
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground mb-1">
                {getActivityLabel(activity)}
              </p>
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <span>{activity?.timestamp}</span>
                {activity?.from && (
                  <>
                    <span>•</span>
                    <span>From {activity?.from}</span>
                  </>
                )}
                {activity?.to && (
                  <>
                    <span>•</span>
                    <span>To {activity?.to}</span>
                  </>
                )}
              </div>
            </div>

            <div className="text-right">
              <p className="text-sm font-semibold text-foreground">
                ${activity?.usdValue?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </p>
              <div className="flex items-center gap-1 justify-end mt-1">
                <div className="w-2 h-2 rounded-full bg-success" />
                <span className="text-xs text-muted-foreground capitalize">{activity?.status}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;